import React, { useState } from 'react';
import { useTheme } from './ThemeProvider';
import { TabProps } from 'tmwx-design-common';
import Surface from './Surface';
import Button from './Button';
import { styles } from '../utils/commonStyles';

const Tab: React.FC<TabProps> = ({
    menuItems,
    elevation = 3,
    defaultSelectedIndex = 0,
    contentMode = 'unmount',
    style,
}) => {
    const { padding } = useTheme();
    const [selected, setSelected] = useState<number>(defaultSelectedIndex)

    return (
        <Surface style={{ ...{ padding: padding }, ...style }} elevation={elevation} rounded>
            <div style={{ ...styles.row, ...{ overflowX: 'auto', paddingBottom: padding } }}>
                {
                    menuItems.map((item, index) => {
                        if (!item.title && !item.icon) {
                            return null
                        }

                        return (
                            <Button
                                key={index}
                                style={styles.marginRight8}
                                status={selected === index ? 'primary' : 'neutral'}
                                variant={selected === index ? 'contained' : 'ghost'}
                                iconLeft={item.icon && item.icon}
                                onPress={() => setSelected(index)}
                            >
                                {item.title}
                            </Button>
                        )
                    })
                }
            </div>

            {contentMode === 'keep' ? (
                <div>
                    {
                        menuItems.map((item, index) => (
                            <div key={index} style={{ display: selected === index ? 'block' : 'none' }}>
                                {item.component}
                            </div>
                        ))
                    }
                </div>
            ) : (
                <div>
                    {menuItems[selected].component}
                </div>
            )}


        </Surface >
    );
};

export default Tab;